import React, { useState, useEffect } from 'react';
import { getCollectState } from '../api/strategy';

function CollectingOverlay({ children }) {
  const [collectState, setCollectState] = useState(null);

  useEffect(() => {
    const check = async () => {
      try {
        const state = await getCollectState();
        setCollectState(state);
      } catch {
        setCollectState(null);
      }
    };
    check();
    const interval = setInterval(check, 10000);
    return () => clearInterval(interval);
  }, []);

  if (!collectState?.is_collecting) return children;

  const startedAt = collectState.started_at ? new Date(collectState.started_at) : null;
  const elapsed = startedAt ? Math.floor((Date.now() - startedAt.getTime()) / 1000) : 0;
  const elapsedMin = Math.floor(elapsed / 60);
  const elapsedSec = elapsed % 60;

  return (
    <>
      {children}
      <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
        <div className="bg-white rounded-xl shadow-lg px-8 py-6 text-center max-w-sm">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <div className="text-gray-700 font-medium text-lg">데이터 수집 중...</div>
          <div className="text-blue-600 mt-2">{collectState.step}</div>
          <div className="text-gray-400 text-sm mt-1">
            경과 {elapsedMin}분 {elapsedSec}초
          </div>
          <div className="text-gray-400 text-xs mt-2">
            페이지 로딩이 느려질 수 있습니다
          </div>
        </div>
      </div>
    </>
  );
}

export default CollectingOverlay;
